const addresses = [
  {
    id: 1,
    name: "John Doe",
    address: "1234 Main Street, Apartment 5B, Cityville, Countryland, 12345",
    phoneNumber: "+1 123 456 7890",
  },
  {
    id: 2,
    name: "Jane Smith",
    address: "456 Elm Avenue, Unit 10, Townsville, Countryland, 54321",
    phoneNumber: "+1 987 654 3210",
  },
  {
    id: 3,
    name: "David Johnson",
    address: "789 Oak Lane, Suite 200, Villageton, Countryland, 98765",
    phoneNumber: "+1 555 123 4567",
  },
];

export { addresses };
